module.exports = __webpack_public_path__ + "static/media/DMCCStamp.d8860f75.jpg";